module.exports = __webpack_public_path__ + "static/media/Oct12-17.c70fdcaa.png";